import { initialState } from "./index";
import { createSelector } from "@reduxjs/toolkit";

const selectCreatorsState = (state) => state.creators || initialState;

export const selectCreators = createSelector(
  [selectCreatorsState],
  (creatorsState) => creatorsState.creators
);
